import { getAllProvidersFromWindow } from '@dynamic-labs-sdk/client/core';

import type { EIP1193Provider } from '../../../EvmWalletProvider.types';

// eslint-disable-next-line custom-rules/ban-ethereum-eth-terms -- window.ethereum is the standard EIP-1193 injection point
const EVM_PROVIDER_LOCATOR = 'ethereum';

/**
 * Gets all EIP-1193 providers from window.ethereum and window.ethereum.providers.
 *
 * This function collects all injected EVM providers from the window object,
 * handling both single provider and multi-provider (EIP-5749) scenarios.
 *
 * This is particularly important for wallet app in-app browsers (e.g., MetaMask
 * mobile, Trust Wallet, Coinbase Wallet) which inject their provider into
 * window.ethereum rather than announcing via EIP-6963.
 *
 * @returns Array of all detected EIP-1193 providers
  * @not-instrumented
 */
export const getEvmInjectedProviders = (): EIP1193Provider[] => {
  const providers = getAllProvidersFromWindow<EIP1193Provider>(
    EVM_PROVIDER_LOCATOR
  );

  // Filter to only include objects that look like EIP-1193 providers
  return providers.filter(isEIP1193Provider);
};

// eslint-disable-next-line custom-rules/one-function-per-file
const isEIP1193Provider = (provider: unknown): provider is EIP1193Provider => {
  if (typeof provider !== 'object' || provider === null) {
    return false;
  }

  const p = provider as Record<string, unknown>;

  // Must have request method - the core EIP-1193 requirement
  return typeof p.request === 'function';
};
